"use client";

import { FC, useEffect } from "react";
import { useAtom } from "jotai";
import { toastAtom } from "@/app/_lib/atoms/toast.atom";
import classNames from "classnames";
import { MdCheck, MdError, MdInfo, MdSync, MdWarning } from "react-icons/md";
import cx from 'classnames';

const Toast: FC = () => {
  const [toasts, setToasts] = useAtom(toastAtom);

  useEffect(() => {
    const timer = setTimeout(() => {
      setToasts((toasts) => {
        return toasts.map((toast) => {
          if (toast.state === "active") {
            return { ...toast, state: "dismissed" };
          }
          return toast;
        });
      });
    }, 5000);

    return () => clearTimeout(timer);
  }, [toasts.length, setToasts]);

  /**
   * Clear out dismissed toasts every minute
   */
  useEffect(() => {
    const interval = setInterval(() => {
      setToasts((prevToasts) => prevToasts.filter(toast => toast.state !== "dismissed"));
    }, 60000); // 60000 milliseconds = 1 minute

    return () => clearInterval(interval);
  }, [setToasts]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast toast-end pointer-events-none z-50">
      {toasts.map((toast, index) => (
        <div
          key={index}
          className={classNames(`alert flex flex-row gap-x-1.5 items-start max-w-md pv-4 rounded-md`, {
            ["alert-info"]: toast.type === "info",
            ["alert-success"]: toast.type === "success",
            ["alert-warning"]: toast.type === "warning",
            ["alert-error"]: toast.type === "error",
            ["alert-dismissed"]: toast.state === "dismissed",
            ["alert-loading"]: toast.type === "loading",
          })}
        >
          <div>
            {toast.type === "info" ? (
              <MdInfo className="text-white w-4 h-4" />
            ) : toast.type === "success" ? (
              <MdCheck className="text-white w-4 h-4" />
            ) : toast.type === "warning" ? (
              <MdWarning className="text-black w-4 h-4" />
            ) : toast.type === "error" ? (
              <MdError className="text-white w-4 h-4" />
            ) : toast.type === "loading" && (
              <MdSync className="text-white animate-spin w-4 h-4" />
            )}
          </div>

          <div className="flex flex-col gap-y-1 text-balance text-wrap">
            {toast.title && <p className={cx("m-0 font-bold leading-4", {
              "text-black": toast.type === "warning",
              "text-white": toast.type !== "warning",
            })}>{toast.title}</p>}
            <p className={cx("m-0 p-0 leading-4", {
              "text-black": toast.type === "warning",
              "text-white": toast.type !== "warning",
            })}>{toast.message}</p>
            {toast.action && (
              <button
                onClick={toast.action.onClick}
                className={cx("m-0 p-0 text-left underline font-medium leading-4 pointer-events-auto cursor-pointer", {
                  "text-black": toast.type === "warning",
                  "text-white": toast.type !== "warning",
                })}
              >
                {toast.action.label}
              </button>
            )}
          </div>
        </div>
      ))}
      <style jsx>{`
        .alert {
          opacity: 1;
        }

        .alert-dismissed {
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Toast;
